import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Icon, Switch } from '@chakra-ui/core'

import { Text, Box, Grid, Tooltip } from '@rockr/rock-ui'
import {
  TableHeader,
  TableContainer,
  TableRow,
  TableData
} from '../../../components/Table'
import { ProductStreamsTable } from '../../../components/ProductStreamsTable'
import { RootState } from '../../../shared/store'
import { OfferInput, Sku } from '../../../shared/types/skus'
import { brlFormatter } from '../../../shared/helpers/formatters'
import { getTotalValue } from '../../../shared/helpers/offer'
import { OfferTag } from '../../../components/OfferTag'
import { editOffer } from '../../../shared/store/offers/actions'
import { DateInput } from '../../../components/DateInput'

export const Recurrence = () => {
  const dispatch = useDispatch()

  const skus = useSelector<RootState, Sku[]>(state => state.skus)
  const offers = useSelector<RootState, OfferInput[]>(state => state.offers)

  const handleOfferAutoRenewable = (index: number, isRenewable: boolean) => {
    const offer = offers.find((offer: OfferInput, idx: number) => idx === index)

    dispatch(editOffer({
      indexTable: index,
      data: {
        ...offer!,
        isRenewable
      }
    }))
  }

  const handleOfferRecurrent = (index: number, isRecurring: boolean) => {
    const offer = offers.find((offer: OfferInput, idx: number) => idx === index)

    dispatch(editOffer({
      indexTable: index,
      data: {
        ...offer!,
        isRecurring
      }
    }))
  }

  const handleStartDate = (index: number, date: string) =>  {
    const offer = offers.find((_: OfferInput, idx: number) => idx === index)
    const startDate = new Date(date)
    dispatch(editOffer({
      indexTable: index,
      data: {
        ...offer!,
        startDate
      }
    }))
  }

  const recurrentIsDisabled = (offer: OfferInput) => {
    return Boolean(offer.bundleId || ['SFW'].includes(offer.skuCode!))
  }

  const renderOffer = (offer: OfferInput, idx:number) => {
    const totalValue = getTotalValue(offer as OfferInput)

    return (
      <TableRow key={idx}>
        <TableData align='left'>{offer.quantity}</TableData>
        <TableData align='left'>
          {offer.displayName} {'\u00A0'}
          <OfferTag offer={offer} />
        </TableData>
        <TableData>{offer.duration}</TableData>
        <TableData>
          <DateInput name='startDate' dateFormat="dd/MM/yyyy" value={new Date(offer.startDate)}  onChange={(e) => handleStartDate(idx, e.target.value)}/>
        </TableData>
        <TableData>{`${offer.index * 100}%`}</TableData>
        <TableData>{brlFormatter.format(offer.dealValue / 100)}</TableData>
        <TableData>
           <Switch size="lg" isChecked={offer.isRenewable} onChange={(e) => handleOfferAutoRenewable(idx, e.target.checked)}/>
         </TableData>
         <TableData>
         <Switch size="lg" 
          isChecked={offer.isRecurring} 
          onChange={(e) => handleOfferRecurrent(idx, e.target.checked)} 
          isDisabled={recurrentIsDisabled(offer)}
         />
         </TableData>
        <TableData>{brlFormatter.format(totalValue / 100)}</TableData>
      </TableRow>
    )
  }

  const calculateMultiplier = (
    index: number,
    quantity: number,
    duration: number
  ): number => index * quantity * duration

  return (
    <section>
      <Grid gridGap={4}>
        <Box>
          <Text marginBottom={6}>Client’s Offers</Text>
          <TableContainer fullWidth>
            <TableRow>
              <TableHeader align='left' label="Qty" />
              <TableHeader align='left' label="Item" />
              <TableHeader label="Duration (months)" />
              <TableHeader label="Start Date" />
              <TableHeader label="Index" />
              <TableHeader label="Deal Value" />
              <TableHeader label="Auto renewable" />
              <TableHeader label="Recurrent" />
              <TableHeader label="Total Value" />
            </TableRow>

            {offers
              .filter(offer => !offer.isChurn)
              .map(renderOffer)
            }
          </TableContainer>
        </Box>

        <Box marginTop={12}>
          <Text marginBottom={6}>
            Total Contract Value {'\u00A0'}
            <Tooltip label='Total Contract Value is...' placement='auto'>
              <Icon name='help' />
            </Tooltip>
          </Text>

          <ProductStreamsTable
            skus={skus}
            offers={offers}
            calculateMultiplier={calculateMultiplier}
            calculateTotal={getTotalValue}
          />
        </Box>
      </Grid>
    </section>
  )
}

